module.exports = __webpack_public_path__ + "img/log-modal-top-bg.361b2b84.png";